import React, { ReactElement } from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { gray80, gray100 } from '../../../constants/colors';
import { boldMd, regularSm } from '../../../constants/location';
import { SUB_PATTERN_ID_BASE } from '../../../constants/enum';
import { subPatternLabel } from '../../../constants/subPattern';
import type { SubPatternType } from '../../../types/subPattern';

type Props = {
  /** 選択肢に出す子パターン。呼び出し側で空のときは描画しないこと */
  subPatterns: SubPatternType[];
  /** 選択中の子パターンID。'base' は子パターンを使わず読取パターンの設定で読む */
  value: string;
  onChange: (subPatternId: string) => void;
};

const styles = {
  section: {
    marginTop: '20px',
  },
  label: {
    ...boldMd,
    color: gray100,
    marginBottom: '4px',
  },
  helperText: {
    ...regularSm,
    color: gray80,
    marginBottom: '8px',
  },
};

/**
 * 再読み取りで使う子パターンの選択欄（#2967）。
 * 判定が誤っていた場合に、正しい子パターンを選んで読み直せるようにする。
 * 一般ユーザーの確認モーダルと運営スタッフの再読取設定モーダルで共通に使う（#3333）
 */
const SubPatternReOcrSelect = ({ subPatterns, value, onChange }: Props): ReactElement => (
  <Box sx={styles.section}>
    <Typography sx={styles.label}>{subPatternLabel.reOcrSelect}</Typography>
    <Typography sx={styles.helperText}>{subPatternLabel.reOcrSelectHelper}</Typography>
    <RadioGroup value={value} onChange={(e): void => onChange(e.target.value)}>
      <FormControlLabel
        value={SUB_PATTERN_ID_BASE}
        control={<Radio size="small" />}
        label={<Typography sx={regularSm}>{subPatternLabel.reOcrBaseOption}</Typography>}
      />
      {subPatterns.map(variant => (
        <FormControlLabel
          key={variant.subPatternId}
          value={variant.subPatternId}
          control={<Radio size="small" />}
          label={<Typography sx={regularSm}>{variant.sub_pattern_name}</Typography>}
        />
      ))}
    </RadioGroup>
  </Box>
);

export default SubPatternReOcrSelect;
